import React, { useRef } from 'react';
import { importCSV } from '../utils/api';

export default function Import({ toast }) {
  const fileRef = useRef();

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    try {
      const r = await importCSV(file);
      toast(`${r.data.imported} lead${r.data.imported !== 1 ? 's' : ''} imported!`);
      if (r.data.errors?.length > 0) console.warn('Import errors:', r.data.errors);
    } catch { toast('Import failed. Check CSV format.'); }
    e.target.value = '';
  };

  const downloadSample = () => {
    const csv = 'name,phone,email,company,service,source,status,followup_date,notes\nRamesh Gupta,+91 98000 11111,ramesh@company.com,Gupta Co,SEO,Website,Hot,2025-06-10,Interested in SEO';
    const a = document.createElement('a');
    a.href = 'data:text/csv,' + encodeURIComponent(csv);
    a.download = 'sample_leads.csv'; a.click();
  };

  return (
    <div>
      <div className="section-header"><div className="section-title">Import Leads</div></div>
      <div className="card" style={{ marginBottom: 16 }}>
        <div className="card-title">Upload CSV File</div>
        <div className="import-zone" onClick={() => fileRef.current?.click()}>
          <i className="ti ti-file-spreadsheet" style={{ fontSize: 28, color: 'var(--gray-400)', marginBottom: 8, display: 'block' }} />
          <div style={{ fontWeight: 500, marginBottom: 4 }}>Click to upload or drag & drop</div>
          <div style={{ fontSize: 12, color: 'var(--gray-400)' }}>CSV format only · Max 1000 rows</div>
          <input ref={fileRef} type="file" accept=".csv" style={{ display: 'none' }} onChange={handleFile} />
        </div>
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8 }}>Expected CSV columns:</div>
        <div style={{ fontFamily: 'monospace', fontSize: 12, background: 'var(--gray-50)', padding: '10px 14px', borderRadius: 7, color: 'var(--gray-600)' }}>
          name, phone, email, company, service, source, status, followup_date, notes
        </div>
        <div style={{ marginTop: 12 }}>
          <button className="btn btn-outline btn-sm" onClick={downloadSample}><i className="ti ti-download" /> Download Sample CSV</button>
        </div>
      </div>
      {/* Used to show a webhook URL and verify-token instructions to paste into
          Meta Business Manager. Connecting is now a single button in Settings,
          and there is no per-tenant webhook URL to hand out any more. */}
      <div className="card">
        <div className="card-title">Facebook Instant Forms</div>
        <div style={{ fontSize: 13, marginBottom: 12, color: 'var(--gray-600)' }}>
          Connect your Facebook page once and every Instant Form lead is captured automatically — no setup needed.
        </div>
        <a className="btn btn-outline btn-sm" href="/settings">
          <i className="ti ti-brand-facebook" /> Connect in Settings
        </a>
      </div>
    </div>
  );
}